// Live's hand-off line under a template's form (`generations-status`, spec G14-templates PR 15):
// once the run is the server's, its check, its words, and its x, which dismisses it.
import { CloseButton, Group, Text } from "@mantine/core";
import { CircleCheck } from "lucide-react";

import classes from "./forms.module.css";

export function HandoffNotice({ message, onDismiss }: { message: string; onDismiss: () => void }) {
  return (
    <output className={classes.handoff}>
      <Group gap={8} wrap="nowrap" align="flex-start">
        <CircleCheck size={16} className={classes.handoffIcon} aria-hidden />
        <Text size="xs" className={classes.handoffText}>
          {message}
        </Text>
        <CloseButton size="sm" variant="subtle" aria-label="Dismiss" onClick={onDismiss} />
      </Group>
    </output>
  );
}
